
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venda-direta/cnpj",
      function () {
        return require("private-next-pages/venda-direta/cnpj.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venda-direta/cnpj"])
      });
    }
  